import { jsxs as c, jsx as l } from "react/jsx-runtime";
import B, { useId as D } from "react";
import { c as s } from "../../clsx-OuTLNxxd.js";
import { e as E } from "../../error-eeUeT3Cz.js";
const L = B.forwardRef(
  ({
    id: u = "",
    value: i = "",
    label: p = "",
    placeholder: f = " ",
    disabled: e = !1,
    error: t = !1,
    helperText: r = "",
    containerClassesName: d = "",
    inputWrapperClassName: h = "",
    inputClassName: x = "",
    labelClassName: b = "",
    helperTextClassName: g = "",
    helperWrapperClassName: w = "",
    type: m = "text",
    startIcon: a,
    endIcon: o,
    startIconClassName: v = "",
    endIconClassName: y = "",
    autoComplete: N,
    onChange: C
  }, j) => {
    const k = D(), R = s(
      // Layout
      "flex flex-col gap-1 overflow-hidden",
      // Additional Classes
      d
    ), W = s(
      // Layout
      "relative w-full overflow-hidden",
      // Additional Classes
      h
    ), _ = s(
      // Layout
      "peer w-full h-16 overflow-hidden rounded",
      // Background and Border
      "border border-transparent transition-all",
      // Typography
      "text-body-b3-regular pb-4 focus:pb-4 placeholder-shown:py-5",
      {
        "pt-4 focus:pt-4": p.length === 0,
        "pt-7 focus:pt-7 ": p.length > 0,
        "px-4 focus:px-4 placeholder-shown:px-4": !a && !o,
        "pr-4 pl-9 focus:pr-4 focus:pl-9 placeholder-shown:pr-4 placeholder-shown:pl-9": a,
        "pl-4 pr-9 focus:pl-4 focus:pr-9 placeholder-shown:pl-4 placeholder-shown:pr-9": o
      },
      // Appearance
      "appearance-none outline-none outline-0",
      // State Styles
      "disabled:bg-input-surface-disabled disabled:cursor-default focus:shadow-focused-input focus:border-input-stroke-active hover:border-input-stroke-active",
      // Placeholder Styles
      "placeholder:opacity-0 focus:placeholder:opacity-100",
      {
        "bg-input-surface-active": !t && !e,
        "bg-input-surface-error": t && !e,
        "bg-input-surface-disabled": e
      },
      // Additional Classes
      x
    ), F = s(
      // Layout
      "flex w-full absolute pointer-events-none px-4",
      // Typography
      "select-none truncate text-label-b5-regular text-input-text-label",
      // State Styles
      "peer-disabled:text-input-text-disabled peer-disabled:peer-placeholder-shown:text-input-text-disabled transition-all peer-placeholder-shown:text-input-text-placeholder",
      // Positioning
      "top-3 left-0",
      // Placeholder Shown State
      "peer-placeholder-shown:text-body-b3-regular peer-focus:text-body-b3-regular peer-placeholder-shown:translate-x-0 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-placeholder-shown:left-0",
      // Focus State
      "peer-focus:translate-x-0 peer-focus:translate-y-0 peer-focus:top-3 peer-focus:left-0 peer-focus:text-label-b5-regular peer-focus:text-input-text-label",
      b
    ), n = s(
      {
        "flex gap-2 pl-4": typeof r == "string",
        "pl-4": typeof r != "string"
      },
      w
    ), q = s(
      "text-label-b5-regular",
      {
        "text-input-text-error": t,
        "text-input-text-disabled": !t
      },
      g
    ), z = s(
      "w-8 h-[calc(100%-2px)] absolute left-[1px] top-1/2 -translate-y-1/2 flex items-center justify-center cursor-pointer",
      {
        "bg-input-surface-active": !t && !e,
        "bg-input-surface-error": t && !e,
        "bg-input-surface-disabled": e
      },
      v
    ), A = s(
      "w-8 h-[calc(100%-2px)] absolute right-[1px] top-1/2 -translate-y-1/2 flex items-center justify-center cursor-pointer",
      {
        "bg-input-surface-active": !t && !e,
        "bg-input-surface-error": t && !e,
        "bg-input-surface-disabled": e
      },
      y
    );
    return /* @__PURE__ */ c("div", { className: R, children: [
      /* @__PURE__ */ c("div", { className: W, children: [
        a && /* @__PURE__ */ l("div", { className: z, children: a }),
        /* @__PURE__ */ l(
          "input",
          {
            ref: j,
            id: u || k,
            placeholder: f,
            value: i,
            onChange: C,
            disabled: e,
            className: _,
            type: m,
            autoComplete: N
          }
        ),
        /* @__PURE__ */ l("label", { className: F, children: p }),
        o && /* @__PURE__ */ l("div", { className: A, children: o })
      ] }),
      r && (typeof r == "string" ? /* @__PURE__ */ c("div", { className: n, children: [
        t && /* @__PURE__ */ l(
          "img",
          {
            src: E,
            alt: "error"
          }
        ),
        /* @__PURE__ */ l("p", { className: q, children: r })
      ] }) : /* @__PURE__ */ l("div", { className: n, children: r }))
    ] });
  }
);
export {
  L as TextField
};
